export namespace JobCode {
  export enum TipType {
    DIRECT = 'DIRECT',
    INDIRECT = 'INDIRECT',
  }
}
